import AppLayout from "../../Components/Layout/Layout"

export const HomePage = () =>{
    return(
        <AppLayout>
            <></>
        </AppLayout>
    )
}